import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../commonComponents/modal/Modal';
import FormInput from '../../../commonComponents/forms/FormInput';
import ScrollContainer from '../../../commonComponents/container/ScrollContainer';
import translate from '../../../commonComponents/translate';

function BinaryUsersOnHold(props) {
  const {
    t,
    filters,
    onFiltersChange,
    onCloseModal,
    filteredAvailableUsers,
    onReachedEnd,
  } = props;

  return (
    <Modal id="binaryUsersOnHold" onClose={onCloseModal} tabIndex={null}>
      <div className="popup-container">
        <div className="popup">
          <div className="modal-header">
            <h5 className="modal-title">{t('users.on.hold')}</h5>
            <button type="button" className="close" onClick={onCloseModal}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  // eslint-disable-next-line max-len
                  d="M19.324 3.93931L13.2641 9.99986L19.324 16.0601C20.2253 16.9619 20.2253 18.4225 19.324 19.3243C18.8736 19.7746 18.2831 20 17.6929 20C17.1018 20 16.5113 19.775 16.0612 19.3243L10 13.2633L3.93929 19.3242C3.48897 19.7746 2.89844 19.9999 2.30775 19.9999C1.71722 19.9999 1.1271 19.7749 0.676378 19.3242C-0.225 18.4229 -0.225 16.9621 0.676378 16.0601L6.73609 9.99981L0.676033 3.93931C-0.225344 3.03793 -0.225344 1.5769 0.676033 0.675521C1.57724 -0.225174 3.03739 -0.225174 3.93894 0.675521L9.99997 6.73607L16.0605 0.675521C16.9623 -0.225174 18.4226 -0.225174 19.3236 0.675521C20.2253 1.5769 20.2253 3.03793 19.324 3.93931Z"
                  fill="#6F6C80"
                />
              </svg>
            </button>
          </div>
          <FormInput
            id="search"
            name="search"
            value={filters.search}
            onChange={onFiltersChange('search')}
            labelClassName=""
            containerClassName=""
            placeholder={t('user_selector_placeholder')}
            groupProps={{
              className: 'query-container',
            }}
          />
          <ScrollContainer onReachedEnd={onReachedEnd}>
            {filteredAvailableUsers.map(user => (
              <div role="presentation" className="popup-user">
                <img
                  className="popup-avatar"
                  alt={user.name}
                  src={user.image ? user.image.thumb : '/images/no_user.png'}
                />
                <p>{user.username}</p>
              </div>
            ))}
          </ScrollContainer>
        </div>
      </div>
    </Modal>
  );
}

BinaryUsersOnHold.propTypes = {
  t: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  filteredAvailableUsers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onFiltersChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  onReachedEnd: PropTypes.func.isRequired,
};

export default translate(BinaryUsersOnHold);
